import * as Yup from "yup";

export const loginschema = Yup.object({
  email: Yup.string().required("Please Enter Email"),
  password: Yup.string().min(3).required("Please Enter Password"),
});

export const AddCustodianSchema = Yup.object({
  custodianName: Yup.string().required("Please Enter Custodian Name"),
  custodianDesc: Yup.string().required("Please Enter Custodian Desc"),
  custodianIcon: Yup.string().required("Please Enter Custodian Icon"),
});
